// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import { SingleGameFragmentDoc } from '../../../../shared/graphql/SingleGameFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserLobbyRecommendationQueryVariables = Types.Exact<{
  site: Types.Scalars['String']['input'];
  first: Types.Scalars['Int']['input'];
  currency?: Types.InputMaybe<Types.currencyConversion>;
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UserLobbyRecommendationQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, hub88UserLobbyRecommendation?: { __typename?: 'CasinoGameConnection', totalCount?: number, edges?: Array<{ __typename?: 'CasinoGameEdge', node?: { __typename?: 'CasinoGame', maxBet?: number, blocked?: boolean, blockedReason?: string, volatility?: number, payLines?: string, hitRatio?: number, bgColor?: string, bgImg?: string, id: string, name?: string, handle?: string, thumbUrl?: string, thumbUrlTab?: string, href?: string, isTrending?: boolean, isHot?: boolean, isNew?: boolean, isHighRoller?: boolean, isFavourite?: boolean, inLoyalty?: boolean, rtp?: number, rtpLivePastDay?: number, rtpLivePastSevenDays?: number, rtpLivePastThirtyDays?: number, isFeatured?: boolean, minBet?: number, hasFunMode?: boolean, category?: { __typename?: 'CasinoCategory', id: string, handle?: string }, menuItem?: Array<{ __typename?: 'CasinoGameMenuItem', id: string, handle?: string, name?: string, inGameCurrencies?: string }>, themes?: { __typename?: 'CasinoGameThemeConnection', edges?: Array<{ __typename?: 'CasinoGameThemeEdge', node?: { __typename?: 'CasinoGameTheme', id: string, name?: string, handle?: string } }> } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string, hasNextPage: boolean } } } };


export const UserLobbyRecommendationQueryDocument = /*#__PURE__*/ gql`
    query UserLobbyRecommendationQuery($site: String!, $first: Int!, $currency: currencyConversion, $language: String, $isMobile: Boolean) {
  casino {
    id
    hub88UserLobbyRecommendation(
      first: $first
      site: $site
      language: $language
      isMobile: $isMobile
      hrefPrefix: "/play"
    ) {
      edges {
        node {
          ...SingleGameFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
}
    ${SingleGameFragmentDoc}`;
export function useUserLobbyRecommendationQuery(baseOptions: Apollo.QueryHookOptions<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables> & ({ variables: UserLobbyRecommendationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables>(UserLobbyRecommendationQueryDocument, options);
      }
export function useUserLobbyRecommendationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables>(UserLobbyRecommendationQueryDocument, options);
        }
export function useUserLobbyRecommendationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables>(UserLobbyRecommendationQueryDocument, options);
        }
export type UserLobbyRecommendationQueryHookResult = ReturnType<typeof useUserLobbyRecommendationQuery>;
export type UserLobbyRecommendationQueryLazyQueryHookResult = ReturnType<typeof useUserLobbyRecommendationQueryLazyQuery>;
export type UserLobbyRecommendationQuerySuspenseQueryHookResult = ReturnType<typeof useUserLobbyRecommendationQuerySuspenseQuery>;
export type UserLobbyRecommendationQueryQueryResult = Apollo.QueryResult<UserLobbyRecommendationQuery, UserLobbyRecommendationQueryVariables>;